import type { PropsWithChildren } from 'react';
import { useCallback } from 'react';

import { UserContext } from '../contexts';
import { useWmgSession } from '../hooks/useWmgSession';

export function UserProvider({ children }: PropsWithChildren) {
  const { email, name, permissions, features, isInternal, profile } =
    useWmgSession();

  const hasPermission = useCallback(
    (permission: string, entityID?: string) => {
      if (entityID) {
        return permissions[entityID]?.includes(permission) ?? false;
      }

      return Object.values(permissions).some((items) =>
        items.includes(permission),
      );
    },
    [permissions],
  );

  return (
    <UserContext.Provider
      value={{
        email,
        name,
        permissions,
        hasPermission,
        features,
        isInternal,
        profile,
      }}
    >
      {children}
    </UserContext.Provider>
  );
}

UserProvider.displayName = 'UserProvider';
